export default __webpack_public_path__ + "static/media/zoom.4651df85.jpg";